import React, { Component } from 'react';
import Searchbox from "sushiweb/Searchbox";
import Dropdown from "sushiweb/Dropdown";
import MenuItem from "sushiweb/MenuItem";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class CounterInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      countValue: 0
    }
  }
  
  componentDidMount() {
    this.setState({countValue: this.props.defaultValue})
  }
  
  componentDidUpdate(prevProps){
    if(prevProps.defaultValue !== this.props.defaultValue) {
      this.setState({countValue: this.props.defaultValue})
    }
  }

  setCountValue(e){
    const val = e.target.value;
    let pattern = /^\d+$/;
    if(pattern.test(val) || val == ''){
      this.setState({countValue: val});
      this.props.getValue(val)
    }
  }

  setBlurCountValue(e){
    if(e.target.value == ''){
      this.setState({countValue: 0});
      this.props.getValue(0)
    }
  }

  handleCounter(type){
    if(type == 'inc'){
      this.setState({countValue: this.state.countValue + 1})
      this.props.getValue(this.state.countValue + 1)
    } else if(type == 'dec' && this.state.countValue > 0 ) {
      this.setState({countValue: this.state.countValue - 1})
      this.props.getValue(this.state.countValue - 1)
    }
  }

  render() {
    return (
      <div className="input-counter input-field-wrap input-field-wrap-counter right">
        <div className={this.state.countValue == 0 ? "decrement disable" : "decrement"} onClick={() => this.handleCounter('dec')}>
          <FontAwesomeIcon icon="minus" />
        </div>
        <input 
          type="text"
          className="input-field__input input-field__input-counter"
          value={this.state.countValue}
          onChange={(e) => this.setCountValue(e)}
          onBlur={(e) => this.setBlurCountValue(e)}
        />
        <div className={this.state.countValue == this.props.max ? "increment disable" : "increment"} onClick={() => this.handleCounter('inc')}>
          <FontAwesomeIcon icon="plus" />
        </div>
        
      </div>
    )
  }
}

export default CounterInput;
